export default __webpack_public_path__ + "static/media/character-6.b7cfa9fc.svg";